import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import {Header} from '../../Components/Header';
import {updatefieldscontact, getLocalFieldsValue} from '../../Services/Contact/action';
import Checkboxes from '../../Components/Checkboxes';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import validator from 'validator';

import './style.scss';

class Step3 extends Component {
    constructor(props, context) {
		super(props, context);

        this.state = {
            activeRow: false,
            validForm: false,
            formsValid: {
                org_nr: false,
                company_name: false,
                adress: false,
                phone: false,
                email: false,
                description: false,
                invoice: false,
                contact: false
            }
            
        }
    }

    validateForm = (e, validation) => {
        debugger
        let value = e.target.value;
        console.log(value);
        const {contact} = this.props;
        delete contact.validForm;
        delete contact.validate;
        delete contact.description;
        this.checkValidation(contact);
    }

    changeInputValue = (e, validation) => {
       let name = e.target.name;
       let value = e.target.value;
       let obj = {
            [name]: value
        }
        this.props.updatefieldscontact(obj);
    }
    checkValidation = (contact) => {
        debugger
        if(contact)
        {
            let object;
            let valid = false;
            let validform = false;
            for (var key in contact)
            {
                console.log(key);
                if(contact[key] == "")
                {
                    this.state.formsValid = Object.assign({}, this.state.formsValid, {
                        [key]: false
                    });
                }else {
                    this.state.formsValid = Object.assign({}, this.state.formsValid, {
                        [key]: true
                    });

                }
                if(key == "phone")
                {
                    if(validator.isNumeric(contact.phone)){
                        if(contact.phone.length == 10 || contact.phone.length == 9 || contact.phone.length == 8)
                        {
                            this.state.formsValid = Object.assign({}, this.state.formsValid, {
                                [key]: true
                            });
                        }else {
                            this.state.formsValid = Object.assign({}, this.state.formsValid, {
                                [key]: false
                            });
                        }
                        
                    }else {
                        this.state.formsValid = Object.assign({}, this.state.formsValid, {
                            [key]: false
                        });
                    }
                }
                if(key == "email")
                {
                    if(validator.isEmail(contact.email)) {
                        this.state.formsValid = Object.assign({}, this.state.formsValid, {
                            [key]: true
                        });
                    }else {
                        this.state.formsValid = Object.assign({}, this.state.formsValid, {
                            [key]: false
                        });
                        
                    }
                    
                }
            }
            let errors = [];
            for(let keyvalid in this.state.formsValid)
            {
                if(this.state.formsValid[keyvalid] == false)
                {
                    if(keyvalid != "description")
                    {
                        errors.push({error: keyvalid})
                    }
                    
                }
                /* if(this.state.formsValid[keyvalid])
                {
                    this.setState({
                        activeButton: true
                    });
                }else {
                    this.setState({
                        activeButton: false
                    });
                } */
            }
            if(errors.length > 0)
            {
                this.setState({
                    activeButton: false
                })
            }else {
                this.setState({
                    activeButton:true
                })
            }
        }
        
        
    }

    checkLocalStorage = () => {
        let localContact = localStorage.getItem('contact-welandutemiljo');
        if(localContact !== null)
        {
            this.props.getLocalFieldsValue(JSON.parse(localContact));
            let contact = JSON.parse(localContact);
            delete contact.validForm;
            delete contact.validate;
            delete contact.description;
            this.checkValidation(contact);
        }
    }

    componentWillMount = () => {
        this.checkLocalStorage();
        
    }
    componentDidMount = () => {
        this.checkValidation();
        
    }

    render = () => {
        const {contact} = this.props;

        return (
            <div className="step3">
                <div className="container is-fluid">
                        <Header title="Skriv in dina uppgifter så vi kan kontakta dig." activeNextButton={this.state.activeButton} subtitle="Steg 3 / 4 Snart färdig" nextPageLink="/4"   />
                        <div className="hero transparent">
                        <div className="hero-body" style={{paddingBottom: '0px'}} >                            
                        </div>
                    </div>
                </div>
                <div className="hero">
                    <div className="hero-body" style={{paddingTop: "1rem"}}>
                        <div className="container">
                            <div className="columns">
                                <div className="column is-12">
                                    <div className="contact-fields">
                                        <div className="input-fields">
                                            {
                                                this.state.formsValid.org_nr ? (<p>Organisationsnummer </p>) : (
                                                    <p>Organisationsnummer <span className="red-color">(Obligatoriskt fält)</span></p>
                                            )
                                            }
                                            
                                            <input type="text" name="org_nr" onBlur={(e) => this.validateForm(e, ['required'])} value={contact.org_nr} onChange={(e) => this.changeInputValue(e, 'email')} placeholder="Ange organisationsnummer" className="input-field" />
                                        </div>
                                        <div className="input-fields">
                                            {
                                                this.state.formsValid.company_name ? (<p>Företagsnamn </p>) : (
                                                    <p>Företagsnamn <span className="red-color" >(Obligatoriskt fält)</span></p>
                                            )
                                            }
                                            <input type="text" name="company_name" onBlur={(e) => this.validateForm(e, ['required'])} value={contact.company_name} onChange={(e) => this.changeInputValue(e)}  placeholder="Ange företagsnamn" className="input-field" />
                                        </div>
                                        <div className="input-fields">
                                            {
                                                this.state.formsValid.invoice ? (<p>Fakturaadress </p>) : (
                                                    <p>Fakturaadress <span className="red-color" > (Obligatoriskt fält)</span></p>
                                            )
                                            }
                                            <input type="text" name="invoice" onBlur={(e) => this.validateForm(e, ['required'])} value={contact.invoice} onChange={(e) => this.changeInputValue(e)}  placeholder="Ange fakturaadress" className="input-field" />
                                        </div>
                                        <div className="input-fields">
                                            {
                                                this.state.formsValid.adress ? (<p>Leveransadress </p>) : (
                                                    <p> Leveransadress <span className="red-color">(Obligatoriskt fält)</span></p>
                                            )
                                            }
                                            <input type="text" name="adress" onBlur={(e) => this.validateForm(e, ['required'])} value={contact.adress} onChange={(e) => this.changeInputValue(e)}  placeholder="Ange leveransadress" className="input-field" />
                                        </div>
                                        <div className="input-fields">
                                            {
                                                this.state.formsValid.contact ? (<p>Kontaktperson </p>) : (
                                                    <p >Kontaktperson <span className="red-color" >(Obligatoriskt fält)</span></p>
                                            )
                                            }
                                            <input type="text" name="contact" onBlur={(e) => this.validateForm(e, ['required'])} value={contact.contact} onChange={(e) => this.changeInputValue(e)}  placeholder="Ange kontaktperson" className="input-field" />
                                        </div>
                                        <div className="input-fields">
                                            {
                                                this.state.formsValid.phone ? (<p>Telefonnummer </p>) : (
                                                    <p>Telefonnummer <span className="red-color" >(Obligatoriskt fält)</span></p>
                                            )
                                            }
                                            <input type="text" name="phone" onBlur={(e) => this.validateForm(e, ['required'])} value={contact.phone} onChange={(e) => this.changeInputValue(e)}  placeholder="Ange telefonnummer" className="input-field" />
                                        </div>
                                        <div className="input-fields">
                                            {
                                                this.state.formsValid.email ? (<p>E-post </p>) : (
                                                    <p>E-post <span className="red-color">(Obligatoriskt fält)</span></p>
                                            )
                                            }
                                            <input name="email" type="email" value={contact.email} onBlur={(e) => this.validateForm(e, ['required', 'email' ])}  onChange={(e) => this.changeInputValue(e)}  placeholder="Ange e-postadress" className="input-field" />
                                            
                                        </div>
                                        <div className="input-fields">
                                            <p>Övrig information </p>
                                            <textarea placeholder="Lägg till övrig information" className="textarea-field" value={contact.description} onChange={(e) => this.changeInputValue(e)} rows="6" name="description">
                                            </textarea>
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


}

const mapStateToProps = (state) => {
    return {
        contact: state.contact
    };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updatefieldscontact: bindActionCreators(updatefieldscontact, dispatch),
    getLocalFieldsValue: bindActionCreators(getLocalFieldsValue, dispatch)
  };
}; 
export default connect(mapStateToProps, mapDispatchToProps)(Step3);


// WEBPACK FOOTER //
// ./src/Scenes/Step3/index.js